import React from 'react'
import { Box, Typography, Tooltip } from '@the-platform-group/component-library'
import { Grid } from '@the-platform-group/component-library/Layout'
import { formatDate } from '@the-platform-group/formatters/dateFormat'

/**
 * Phone Grader Component that displays the details of the phone number like is it premium, type, validity, and last checked
 * @param {Object} phone - The phone object
 * @returns {React.Component} - The PhoneGrader component
 */
const PhoneGrader = ({ phone }) => {
  const isPremium = phone?.premium

  return (
    <Tooltip
      title={
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body2">{isPremium ? 'Premium' : 'Regular'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Type: {phone?.type}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Validity: {phone?.validity}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Last Checked: {formatDate(phone?.lastChecked)}</Typography>
          </Grid>
        </Grid>
      }
    >
      <Box
        sx={{
          ...(isPremium
            ? {
                bgcolor: 'success.main',
              }
            : {
                border: '1px solid',
                borderColor: 'warning.main',
              }),
          borderRadius: 1,
          width: 18,
          height: 18,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: isPremium ? 'primary.brighter' : 'primary.dark',
        }}
      >
        <Typography variant="body2">{isPremium ? 'P' : 'R'}</Typography>
      </Box>
    </Tooltip>
  )
}

export default PhoneGrader
